import { render } from "./customizeColumnModal.vue?vue&type=template&id=4740e724&scoped=true"
import script from "./customizeColumnModal.vue?vue&type=script&lang=js"
export * from "./customizeColumnModal.vue?vue&type=script&lang=js"

import "./customizeColumnModal.vue?vue&type=style&index=0&id=4740e724&lang=less&scoped=true"
import "./customizeColumnModal.vue?vue&type=style&index=1&id=4740e724&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4740e724"]])

export default __exports__